const resumeData = {
  name: 'Antony',
  landingIntro: "I'm a Full Stack Software Engineer & Program and Product Operations Leader. I'm always looking for opportunities to collaborate on new projects- so feel free to reach out!",
  socialLinks: [
    {
      name: 'email',
      url: 'mailto:hello@antonyyu.com',
      className: 'fa fa-solid fa-envelope'
    },
    {
      name: 'linkedin',
      url: 'https://www.linkedin.com/in/antonyyu/',
      className: 'fa fa-linkedin'
    },
    {
      name: 'github',
      url: 'https://github.com/Antonomy',
      className: 'fa fa-github'
    }
  ],
  aboutMe: "I am a user-obsessed, technical, and operationally minded leader with 10 years of experience in tech and program operations. Having built teams globally in 16 countries, I am no stranger to working in fast-paced, hybrid, and global conditions. I'm passionate about engineering simple solutions to complex problems. During my experiences at Riot Games and Tencent, I held roles in leadership, program operations, and organizational transformation, which honed my strengths in change management, mentorship, and delivery operations leading me to my adventure at Huckleberry as VP Operations. A common thread throughout my career is my ability to enthusiastically coach and mentor my colleagues to grow their self confidence and regularly challenge convention. I extended this passion by becoming a full stack software engineer - I am looking to use my relationship building skills to create products and experiences that are at the intersection of building community and advancements in technology.",
  email: 'hello@antonyyu.com',
  formspreeEndpoint: 'https://formspree.io/f/myknnaag',
  work: [
    {
      companyName: 'Paychex',
      title: 'Software Engineer',
      startMonth: 'May',
      startYear: '2023',
      endMonth: 'Present',
      endYear: '',
      achievements: ''
    },
    {
      companyName: 'Huckleberry',
      subtitle: 'Acquired by Paychex',
      title: 'VP Operations',
      startMonth: 'Jan',
      startYear: '2020',
      endMonth: 'Present',
      endYear: '',
      achievements: ''
    },
    {
      companyName: 'Tencent',
      title: 'Senior Manager, Global Esports',
      startMonth: 'Sept',
      startYear: '2018',
      endMonth: 'Apr',
      endYear: '2020',
      achievements: ''
    },
    {
      companyName: 'Riot Games',
      title: 'Manager, Global Esports Live Production',
      startMonth: 'Aug',
      startYear: '2014',
      endMonth: 'Sept',
      endYear: '2018',
      achievements: ''
    }
  ],
  education: [
    {
      institutionName: 'General Assembly',
      degree: 'Full Stack Software Engineering',
      graduationMonth: 'February',
      graduationYear: '2022',
      achievements: ''
    },
    {
      institutionName: 'California State University, Los Angeles (CSULA)',
      degree: 'Master of Business Administration (MBA)',
      graduationMonth: 'March',
      graduationYear: '2013',
      achievements: ''
    },
    {
      institutionName: 'University of California, San Diego (UCSD)',
      degree: 'Psychology | Business Management | Law Minor',
      graduationMonth: 'March',
      graduationYear: '2010',
      achievements: ''
    }

  ],
  skillsDescription: 'Technical Skills',
  skills: [
    {
      skillName: 'React'
    },
    {
      skillName: 'HTML'
    },
    {
      skillName: 'CSS'
    },
    {
      skillName: 'JavaScript'
    },
    {
      skillName: 'MongoDB'
    },
    {
      skillName: 'Express'
    },
    {
      skillName: 'Node'
    }
  ],
  contactBadges: [
    {
      url: 'https://github.com/Antonomy',
      name: 'GitHub',
      img: 'https://img.shields.io/badge/GitHub-41454A.svg?&style=for-the-badge&logo=Github&logoColor=white'
    },
    {
      url: 'https://www.linkedin.com/in/antonyyu/',
      name: 'LinkedIn',
      img: 'https://img.shields.io/badge/linkedin-%230077B5.svg?&style=for-the-badge&logo=linkedin&logoColor=white'
    },
    {
      url: 'mailto:hello@antonyyu.com',
      name: 'Email Me',
      img: 'https://img.shields.io/badge/Email%20me-EA4335.svg?&style=for-the-badge&logo=gmail&logoColor=white'
    },
    {
      url: 'https://calendly.com/antonyyu',
      name: 'Book Time on My Calendar',
      img: 'https://img.shields.io/badge/Book%20Time%20with%20me-4285F4.svg?&style=for-the-badge&logo=googlecalendar&logoColor=white'
    }
  ]
}

export default resumeData
